function formatDobForPassword(date: Date | null): string {
  if (date == null || Number.isNaN(date.getTime())) {
    return "";
  }

  const iso = date.toISOString().slice(0, 10);
  return iso.replace(/\D/g, "");
}

export function generatePassword(firstName: string | null | undefined, date: Date | null): string {
  const name = typeof firstName === "string" ? firstName.trim() : "";
  const abbreviation = name.slice(0, Math.min(name.length, 4)).toUpperCase();
  let cleanedDate = formatDobForPassword(date);

  while (cleanedDate.length < 8) {
    cleanedDate = `0${cleanedDate}`;
  }

  return `${abbreviation}${cleanedDate}`;
}

